import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionVenue } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-information-verification',
  templateUrl: 'pap-information-verification.component.html',
  styleUrls: ['./pap-information-verification.component.less', '../../../shared/common.less'],
})

export class PapInformationVerificationComponent implements OnInit {
  @Input() venue: ElectionVenue;
  @Input() isExpanded: boolean = false;
  @Output() venueChange = new EventEmitter<ElectionVenue>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();

  needPap: boolean = undefined;
  isValidated: boolean = false;

  constructor(
  ) {}
  
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  onEdit() {
    this.editRequested.emit();
  }
  
  onVenueChange() {
    this.venueChange.emit(this.venue);
  }
  
  ngOnInit(): void {
  }
}
